import { css } from 'styled-components'
import { media } from 'gipsy-ui'

export const headerPaddingStyle = css`
  padding-left: 40px;
  ${media['phone-wide']`
    padding: 0 16px;
  `}
`



// WEBPACK FOOTER //
// ./src/features/list/styles/index.js